import {
  ChangeDetectorRef,
  Component,
  OnDestroy
} from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MediaMatcher } from '@angular/cdk/layout';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';


import { ChildrenItems, Menu, MenuItems } from '../../../shared/menu-items/menu-items';
import { AppinitService } from '../../../core/services/common/appinit.service';
import { hasAnyRole } from '../../../modules/pools/pool-access';

@Component({
  selector: 'app-vertical-sidebar',
  templateUrl: './vertical-sidebar.component.html',
  styleUrls: []
})

export class VerticalAppSidebarComponent implements OnDestroy {
  public config: PerfectScrollbarConfigInterface = {};
  mobileQuery: MediaQueryList;

  private _mobileQueryListener: () => void;
  status = true;

  itemSelect: number[] = [];
  parentIndex = 0;
  childIndex = 0;
    activeMenuItem: any;
  setClickedRow(i: number, j: number) {
    this.parentIndex = i;
    this.childIndex = j;
  }
  subclickEvent() {
    this.status = true;
  }
  scrollToTop() {
    document.querySelector('.page-wrapper')?.scroll({
      top: 0,
      left: 0
    });
  }
  expandMenuItem: string = '';
  isMenuCollapsed =  false;
  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    private router: Router,
    private appinit: AppinitService
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    // tslint:disable-next-line: deprecation
    this.mobileQuery.addListener(this._mobileQueryListener);

    // Keep the menu in sync with the current route: expand the section that
    // owns the active page (on load and on every navigation).
    this.syncWithRoute(this.router.url);
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => this.syncWithRoute(e.urlAfterRedirects || e.url));
  }

  private syncWithRoute(url: string) {
    const section = this.menuItems.getMenuitem()
      .find(m => url === '/' + m.state || url.startsWith('/' + m.state + '/'));
    if (section) {
      this.expandMenuItem = section.name;
    }
  }

  /** Menu entries the signed-in user may see (entries without roles are visible to everyone). */
  visibleMenu(): Menu[] {
    return this.menuItems.getMenuitem().filter(m => this.canSee(m.roles));
  }

  visibleChildren(menu: Menu): ChildrenItems[] {
    return (menu.children || []).filter(c => this.canSee(c.roles));
  }

  private canSee(roles?: string[]): boolean {
    return !roles || hasAnyRole(this.appinit.userRoles, roles);
  }

  ngOnDestroy(): void {
    // tslint:disable-next-line: deprecation
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  toggleNested(menu,collapsed) {
    this.expandMenuItem = menu.name;
    this.isMenuCollapsed = collapsed;
    
    
  }

}
